import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ProgramOwnerPreorderOutputDto,ServicesProvider } from '@ekhodealer/ekho-common';

import { useCurrentServicesProviderId } from '@common/hooks/useCurrentServicesProviderId';
import { apiClient } from '@config/server/apiClient';
import { configurationEndpoints } from '@config/server/apiEndpoints';
import { queries } from '@config/server/queryKeys';

/**
 * API function to update preorder configuration for a services provider
 */
export const updatePreorder = async (
	servicesProviderId: string,
	data: ProgramOwnerPreorderOutputDto,
): Promise<ServicesProvider> => {
	const response = await apiClient.post<ServicesProvider>(
		configurationEndpoints.preorder(servicesProviderId),
		data,
	);
	return response.data;
};

/**
 * Hook for updating preorder configuration for a services provider
 */
export const useUpdatePreorder = () => {
	const servicesProviderId = useCurrentServicesProviderId();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (data: ProgramOwnerPreorderOutputDto) => {
			if (!servicesProviderId) {
				throw new Error('Unable to update preorder without a services provider ID.');
			}
			return updatePreorder(servicesProviderId, data);
		},
		onSuccess: (data) => {
			// Optimistic cache update
			queryClient.setQueryData(queries.servicesProviders.detail(data.id).queryKey, data);
		},
	});
};
